// /src/api/assignments.js
import { apiGet, apiPost } from "lib/apiClient";

/**
 * Получить список активных назначений (выданных пользователям).
 */
export async function listActiveAssignmentsApp({ q = "", limit, offset } = {}) {
    const params = {};
    if (q) params.q = q;
    if (limit !== undefined) params.limit = limit;
    if (offset !== undefined) params.offset = offset;

    const { data, error } = await apiGet("/assignments/active/", params);
    if (error) throw new Error(error);

    if (data && data.results) {
        return { rows: data.results, count: data.count };
    }
    // Backward compatibility if backend doesn't paginate yet
    if (Array.isArray(data)) {
        return { rows: data, count: data.length };
    }

    return { rows: [], count: 0 };
}

/**
 * Выдать товар пользователю (создать расходный акт + assignment).
 * Возвращает { act_id, assignment_id }.
 */
export async function assignItemToAppUser({
    app_user_id,
    item_id,
    qty,
    price = 0,
}) {
    if (!app_user_id) throw new Error("Не указан app_user_id");
    if (!item_id) throw new Error("Не указан item_id");
    if (qty == null) throw new Error("Не указано qty");

    const { data, error } = await apiPost("/assignments/assign/", {
        app_user_id,
        item_id,
        qty,
        price,
    });

    if (error) throw new Error(error);
    return {
        act_id: data.act_id ?? null,
        assignment_id: data.assignment_id ?? null,
    };
}

/**
 * Выдать НЕСКОЛЬКО товаров пользователю (создать расходный акт + assignments).
 * items: [{ item_id, qty, price }, ...]
 * Возвращает { act_id, assignment_ids }.
 */
export async function assignItemsToAppUser({ app_user_id, items }) {
    if (!app_user_id) throw new Error("Не указан app_user_id");
    if (!items || items.length === 0) throw new Error("Список товаров пуст");

    const { data, error } = await apiPost("/assignments/assign/", {
        app_user_id,
        items,
    });

    if (error) throw new Error(error);
    return {
        act_id: data.act_id ?? null,
        assignment_ids: data.assignment_ids ?? [],
    };
}

/**
 * Оформить возврат по назначению.
 * Возвращает { act_id, assignment_id }.
 */
export async function returnAssignment({ assignment_id, qty, price = 0 }) {
    if (!assignment_id) throw new Error("Не указан assignment_id");
    if (qty == null) throw new Error("Не указано qty");

    const { data, error } = await apiPost("/assignments/return_item/", {
        assignment_id,
        qty,
        price,
    });

    if (error) throw new Error(error);
    return {
        act_id: data.act_id ?? null,
        assignment_id: data.assignment_id ?? null,
    };
}

/* На совместимость со старым называнием */
export { assignItemToAppUser as assignItem };
